import React from 'react';

import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Tooltip from 'react-bootstrap/Tooltip';
import OverlayTrigger from 'react-bootstrap/OverlayTrigger';

import django from './tech-logos/django.png'; import nodejs from './tech-logos/nodejs.png';
import reactLogo from './tech-logos/react.png'; import bootstrap from './tech-logos/bootstrap.png';
import mongodb from './tech-logos/mongodb.png'; import graphql from './tech-logos/graphql.png';
import figma from './tech-logos/figma.png';

import './about.styles.css';

const renderTooltip = (props) => (
    <Tooltip id="tooltip-bottom">
      {props.text}
    </Tooltip>
);

const About = () => (
    <div id="about">
    <Container fluid className="about">
        <div className="unskew">
            <Row className="d-flex justify-content-center">
                <h2 className="gita">Hi, I'm Gita</h2>
            </Row>
            <Row className="d-flex justify-content-center">
                <p className="desc">
                Computer Science student at the University of Indonesia.
                My current activites are designing and developing web apps.
                In my spare time, I enjoy drawing, taking pictures, making videos, and surfing the internet.
                </p>
            </Row>

            <Row className="d-flex justify-content-center text-center">
                <p className="familiar">
                    Familiar with (but not limited to) and still learning:
                </p>
            </Row>

            <Row className="d-flex justify-content-center text-center logos">
                {/* <div className="logos"> */}
                <Col xs lg="1">
                    <OverlayTrigger placement="bottom" overlay={renderTooltip({ text: "Node.js" })}>
                        <img src={nodejs} alt="nodejs" draggable="false" className="logo" />
                    </OverlayTrigger>
                </Col>

                <Col xs lg="1">
                    <OverlayTrigger placement="bottom" overlay={renderTooltip({ text: "Django" })}>
                        <img src={django} alt="django" draggable="false" className="logo" />
                    </OverlayTrigger>
                </Col>

                <Col xs lg="1">
                    <OverlayTrigger placement="bottom" overlay={renderTooltip({ text: "React.js" })}>
                        <img src={reactLogo} alt="react" draggable="false" className="logo" />
                    </OverlayTrigger>
                </Col>
    
                <Col xs lg="1">
                    <OverlayTrigger placement="bottom" overlay={renderTooltip({ text: "Bootstrap" })}>
                        <img src={bootstrap} alt="bootstrap" draggable="false" className="logo" />
                    </OverlayTrigger>
                </Col>

                <Col xs lg="1">
                    <OverlayTrigger placement="bottom" overlay={renderTooltip({ text: "MongoDB" })}>
                        <img src={mongodb} alt="mongodb" draggable="false" className="logo" />
                    </OverlayTrigger>
                </Col>

                <Col xs lg="1">
                    <OverlayTrigger placement="bottom" overlay={renderTooltip({ text: "GraphQL" })}>
                        <img src={graphql} alt="graphql" draggable="false" className="logo" />
                    </OverlayTrigger>
                </Col>

                <Col xs lg="1">
                    <OverlayTrigger placement="bottom" overlay={renderTooltip({ text: "Figma" })}>
                        <img src={figma} alt="figma" draggable="false" className="logo" />
                    </OverlayTrigger>
                </Col>
                    
                {/* </div> */}
            </Row>
        </div>
    </Container>
    </div>
);

export default About;